import React, { Component } from "react";
import { observer } from "mobx-react";
import modalStore from "stores/ModalStore";

@observer
class DeliveryConnectView extends Component {
  render() {
    const { rootStore } = this.props;
    const layerStore = rootStore.layerStore;
    const title = layerStore.title();
    const postposition = title === "배달의민족" ? "을" : "를";

    return (
      <div
        className={
          "layer_comm layer_common_type alert" +
          (layerStore.getLayerConnectView ? " layer_open" : "")
        }
      >
        <div className="bg"></div>
        <div className="layer_content">
          <div className="wrap">
            <div className="top">
              <p>{title} 연동</p>
              <div className="btn_close btn_close_comm">
                <button onClick={() => layerStore.setLayerConnectView(false)}>
                  <span>닫기</span>
                </button>
              </div>
            </div>
            <div className="content">
              <p>
                현재 매장에서 {title}
                {postposition} 통해
              </p>
              <p>주문을 받고 계신가요?</p>
              <div>
                <div className="img"></div>
              </div>
            </div>
            <div className="view_bottom">
              <div>
                <div className="divider"></div>
              </div>
              <div className="btn">
                <button
                  onClick={() => {
                    layerStore.setLayerConnectView(false);
                    layerStore.setLayerConfirmView(true);
                  }}
                >
                  아뇨, 아직이에요
                </button>
                <button
                  onClick={() => {
                    layerStore.setLayerConnectView(false);
                    modalStore.openModal("DeliveryConnectBusiness");
                  }}
                >
                  네, 주문 받아요
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DeliveryConnectView;
